import { NizzaAccount, useAccount as useNizzaAccount } from '@nizza/core';
import { createSubscription, updateSubscription } from 'api';
import { useAtom } from 'jotai';
import { useAccountHandlers } from './account-handlers.hook';
import { eventAccountParamsAtom, externalAccountAtom } from './account.state';

export const useAccount = <T = NizzaAccount>() => {
  const {
    account: accountInfo,
    accountStatus: accountInfoStatus,
    refetchAccount: refetchInfoAccount,
  } = useNizzaAccount<T>();

  const [externalAccount, setExternalAccount] = useAtom(externalAccountAtom);
  const [eventAccountParams, setEventAccountParams] = useAtom(
    eventAccountParamsAtom,
  );

  const {
    changeSubscriptionTypeMutation,
    changeSectionMutation,
    changeSubscriptionStatusMutation,
  } = useAccountHandlers();

  return {
    accountInfo,
    accountInfoStatus,
    externalAccount,
    setExternalAccount,
    eventAccountParams,
    setEventAccountParams,
    createSubscription,
    updateSubscription,
    refetchInfoAccount,
    loadingSubscriptionType: changeSubscriptionTypeMutation.isLoading,
    changeSubscriptionType: changeSubscriptionTypeMutation.mutate,
    changeSection: changeSectionMutation.mutate,
    loadingSection: changeSectionMutation.isLoading,
    changeSubscriptionStatus: changeSubscriptionStatusMutation.mutate,
  };
};
